import { useSelector } from 'react-redux'
import { PmiStatus } from '../../../../types/pmi'
import { defineMessages, useIntl } from 'react-intl'
import { RootState } from '../../../../types/rootState'
import { ProgressBar } from '../../../shared/ProgressBar'
import {
  LTCV_FOR_PMI_REMOVAL,
  NOT_YET,
  SOON,
} from '../ProvidedPmiModule/pmiConstants'

import styles from './PmiProgressBar.module.scss'

export const MSG = defineMessages({
  removalGoal: {
    id: 'PMI.timelineForRemoval.removalGoal',
    defaultMessage: 'Removal Goal',
  },
})

export interface PmiProgressBarProps {
  ltcvPercent: number
}

export const PmiProgressBar = ({ ltcvPercent }: PmiProgressBarProps) => {
  const intl = useIntl()
  const equity = 100 - ltcvPercent
  const basePercent = (equity / (100 - LTCV_FOR_PMI_REMOVAL)) * 100
  const overridePercentFilled = equity > 20 ? '20%' : `${Math.floor(equity)}%`
  const pmiStatus = useSelector<RootState, PmiStatus>(state => state.pmi.status)
  const percentFilled =
    basePercent > 100 ? 100 : basePercent < 0 ? 0 : Math.floor(basePercent)

  return (
    <div className={styles.container}>
      <ProgressBar
        percentFilled={percentFilled}
        goalPostLabel={intl.formatMessage(MSG.removalGoal)}
        overridePercentFilledValue={overridePercentFilled}
        fillColor={
          pmiStatus === NOT_YET
            ? styles.red
            : pmiStatus === SOON
            ? styles.orange
            : styles.green
        }
      />
    </div>
  )
}
